import Child from './Child';
import './adventure.css';

export default function Adventure() {
  return (
    <div className="container">
      <Child />
    </div>
  );
}
